import React from 'react';
import JBImage from 'components/essentials/JBImage';

const BUILD_YOUR_OWN_MOBILE_LINK =
  'https://joybird2.imgix.net/build-your-own-sofa-mobile.svg';

const IconBuildYourOwnMobile = () => (
  <JBImage src={BUILD_YOUR_OWN_MOBILE_LINK} sizes="100vw" />
);

export default IconBuildYourOwnMobile;
